import { ProductRecognitionLayerType } from '../types';

export interface LayerInfo {
  key: ProductRecognitionLayerType;
  label: string;
  color: string;
  bboxColor: string;
  enabledByDefault: boolean;
  /** Single lowercase character that toggles this layer. */
  shortcut: string;
}

export const LAYER_CONFIG: LayerInfo[] = [
  {
    key: 'productPolygons',
    label: 'Product Polygons',
    color: 'bg-blue-500',
    bboxColor: '#3b82f6',
    enabledByDefault: true,
    shortcut: '1',
  },
  {
    key: 'cartonPolygons',
    label: 'Carton Polygons',
    color: 'bg-green-500',
    bboxColor: '#22c55e',
    enabledByDefault: true,
    shortcut: '2',
  },
  {
    key: 'priceTagBoxes',
    label: 'Price Tag Boxes',
    color: 'bg-yellow-500',
    bboxColor: '#eab308',
    enabledByDefault: true,
    shortcut: '3',
  },
  {
    key: 'modPolygons',
    label: 'Mod Polygons',
    color: 'bg-purple-500',
    bboxColor: '#a855f7',
    enabledByDefault: true,
    shortcut: '4',
  },
  {
    key: 'shelfBoxes',
    label: 'Shelf Boxes',
    color: 'bg-orange-500',
    bboxColor: '#f97316',
    enabledByDefault: true,
    shortcut: '5',
  },
  {
    key: 'templateBoxes',
    label: 'Template Boxes',
    color: 'bg-red-500',
    bboxColor: '#ef4444',
    enabledByDefault: true,
    shortcut: '6',
  },
  {
    key: 'templateBoxesUp',
    label: 'Template Boxes Up',
    color: 'bg-red-400',
    bboxColor: '#f87171',
    enabledByDefault: true,
    shortcut: '7',
  },
  {
    key: 'visualObstructions',
    label: 'Visual Obstruction',
    color: 'bg-pink-500',
    bboxColor: '#ec4899',
    enabledByDefault: false,
    shortcut: '8',
  },
  {
    key: 'merchandise',
    label: 'Merchandise',
    color: 'bg-cyan-500',
    bboxColor: '#06b6d4',
    enabledByDefault: false,
    shortcut: '9',
  },
  {
    key: 'hookArea',
    label: 'Hook Area',
    color: 'bg-indigo-500',
    bboxColor: '#6366f1',
    enabledByDefault: false,
    shortcut: '0',
  },
  {
    key: 'fridgeDoors',
    label: 'Fridge Doors',
    color: 'bg-teal-500',
    bboxColor: '#14b8a6',
    enabledByDefault: false,
    shortcut: 'f',
  },
  {
    key: 'topStock',
    label: 'Top Stock',
    color: 'bg-amber-500',
    bboxColor: '#f59e0b',
    enabledByDefault: false,
    shortcut: 't',
  },
  {
    key: 'shelfEdges',
    label: 'Shelf Edges',
    color: 'bg-lime-500',
    bboxColor: '#84cc16',
    enabledByDefault: false,
    shortcut: 'e',
  },
];

// Stacking order for overlays drawn on the image: lower values render first (bottom),
// higher values render last (top) and win clicks when shapes overlap. Layers not
// listed here fall in the middle, keeping their LAYER_CONFIG relative order.
const OVERLAY_LAYER_Z_ORDER: Partial<Record<ProductRecognitionLayerType, number>> = {
  modPolygons: 0,
  shelfBoxes: 1,
  templateBoxes: 2,
  templateBoxesUp: 2,
  cartonPolygons: 4,
  productPolygons: 5,
};
const DEFAULT_OVERLAY_Z_ORDER = 3;

export const OVERLAY_ORDERED_LAYER_CONFIG: LayerInfo[] = [...LAYER_CONFIG].sort(
  (a, b) =>
    (OVERLAY_LAYER_Z_ORDER[a.key] ?? DEFAULT_OVERLAY_Z_ORDER) -
    (OVERLAY_LAYER_Z_ORDER[b.key] ?? DEFAULT_OVERLAY_Z_ORDER)
);
